import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./EditionSelector.css";
import { logEvent } from "../../hooks/useAnalytics"; // ← Añadido

const EditionSelector = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const currentEdition = queryParams.get("edition") || "";

  const editions = ["edition1", "edition2", "edition3", "edition4"];

  const handleEditionChange = (edition) => {
    logEvent({
      category: "EditionSelector",
      action: "Selección de edición",
      label: edition,
    });

    dispatch({ type: "ERASE_DECK" });
    queryParams.set("edition", edition);
    history.push({ pathname: "/crear", search: queryParams.toString() });
  };

  return (
    <div className="edition-selector">
      <h2>Selecciona una edición</h2>
      <div className="edition-buttons">
        {editions.map((ed) => (
          <button
            key={ed}
            className={`edition-button ${currentEdition === ed ? "active" : ""}`}
            onClick={() => handleEditionChange(ed)}
          >
            <div className="edition-image-container">
              <img
                src={`/images/editions/${ed}.webp`}
                alt={ed}
                className="edition-image"
              />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default EditionSelector;
